import awsRumCustomActions from './awsRumCustomActions';

const ecRecommendationActions = {
    RECOMMENDATION_SHOWN: 'RecommendationShown',
    RECOMMENDATION_CLICKED: 'RecommendationClicked',
    RECOMMENDATION_ACCEPTED: 'RecommendationAccepted',
    RECOMMENDATION_DISMISSED: 'RecommendationDismissed',
    RECOMMENDATION_CLOSED: 'RecommendationClosed',
    NOT_NOW_CLICKED: 'NotNowClicked',
    SHOW_ME_HOW_CLICKED: 'ShowMeHowClicked',
    SHOW_ME_HOW_DISMISSED: 'ShowMeHowDismissed',
};

export const ecCycleClosingActions = [
    ecRecommendationActions.RECOMMENDATION_DISMISSED,
    ecRecommendationActions.RECOMMENDATION_CLOSED,
    ecRecommendationActions.NOT_NOW_CLICKED,
    ecRecommendationActions.SHOW_ME_HOW_CLICKED,
    ecRecommendationActions.SHOW_ME_HOW_DISMISSED,
    awsRumCustomActions.HIGH_TEMPERATURE_MODAL_GOT_IT_CLICKED,
    awsRumCustomActions.HIGH_TEMPERATURE_MODAL_CLOSED,
];

export const ecModalRecommendationActions = [
    awsRumCustomActions.HIGH_TEMPERATURE_MODAL_SHOWN,
    awsRumCustomActions.HIGH_TEMPERATURE_MODAL_GOT_IT_CLICKED,
    awsRumCustomActions.HIGH_TEMPERATURE_MODAL_CLOSED,
];

export default ecRecommendationActions;
